import * as infiniteHits from './load_more_results';

window.ProductApprovalsSearch = {
  searchObject: {},
  _currentUser: null,

  initializeSearch(indexParams, searchParams, sortByIndices, currentUser) {
    this.indexParams = indexParams;
    this.searchParams = searchParams;
    this._currentUser = currentUser;
    this._initializeSearchObject();
    this._addWidgets(sortByIndices);
    this.searchObject.start();
    infiniteHits.loadMoreResults();
    this.searchObject.on('render', function () {
      $(document).foundation('reveal', 'reflow');
      return $.cloudinary.responsive();
    });
  },

  _initializeSearchObject() {
    this.searchObject = SearchUtils.createInstantSearch(this.indexParams.appId, this.indexParams.key, this.indexParams.name);
  },

  _addWidgets(sortByIndices) {
    this.searchObject.addWidgets([
      instantsearch.widgets.configure(this.searchParams),
      Widgets.searchBoxWidget('Search...'),
      Widgets.sortBySelectorWidget(sortByIndices),
      this._infiniteHitsWidget(this._currentUser)
    ]);
  },

  _infiniteHitsWidget(currentUser) {
    return instantsearch.widgets.hits({
      container: '#product-approvals-result',
      cssClasses: {
        root: 'ais-Hits',
        list: 'ais-Hits-list list-view grid items borders section-shadow',
        item: 'item'
      },
      transformItems(items) {
        items.map(function (item) {
          item.isDeveloper = currentUser.company_id == item.developer_id;
          item.href = item.isDeveloper ? item.href.concat(`/approvals/${item.objectID}`) : item.href;
          item.isSupplier = currentUser.company_id == item.supplier_id;
          item.isEvaluationSupervisor = item.isDeveloper && ((item.evaluation_supervisor !== undefined && currentUser.id == item.evaluation_supervisor.id) || currentUser.company_admin);
          item.myEvaluation = item.isDeveloper && item.state == 'under_review' && item.evaluations !== undefined && ProductApprovalsSearch._myEvaluation(item, currentUser);
          item.showPrice = item.isSupplier || item.isEvaluationSupervisor || (item.commercial_evaluations && item.commercial_evaluations.find(evaluation => evaluation.evaluator_id == currentUser.id));
          return item;
        });
        return items;
      },
      templates: {
        item: $('#product-approval-template').text(),
        empty: $('#no-search-results-found-template').text()
      }
    });
  },

  _myEvaluation(item, currentUser) {
    const myEvaluation = item.evaluations.find(evaluation => (
      evaluation.evaluator_id == currentUser.id &&
      evaluation.step == item.current_evaluation_step &&
      evaluation.category == item.current_evaluation_category
    ));
    if (myEvaluation) {
      switch (myEvaluation.state) {
        case 'draft': return { draft: true };
        case 'in_progress': return { in_progress: true };
        case 'done': return { done: true };
        case 'submitted': return { submitted: true };
      }
    }
    return {};
  }
};